// test2518
(2518 && 0);
